// 9fbef606107a605d69c0edbcd8029e5d
import { NAVIGATION_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

export default {
  START_SEARCH: `${NAVIGATION_ACTION_PATTERN}START_SEARCH`,
  SET_SEARCH: `${NAVIGATION_ACTION_PATTERN}SET_SEARCH`,
  POPULAR_SEARCH: `POPULAR_SEARCH`,
  TRENDING_SEARCH: `TRENDING_SEARCH`,
  SET_POPULAR_SEARCH: `SET_POPULAR_SEARCH`,
  SET_TRENDING_SEARCH: `SET_TRENDING_SEARCH`,
  RECENT_SEARCH: 'recent-search',
  RECENT_SEARCHES_NUM_MAX: 10,
  MIN_SEARCH_CHARS: 2,
  SET_SHOW_MORE_PRODUCT_FLAG: `${NAVIGATION_ACTION_PATTERN}SET_SHOW_MORE_PRODUCT_FLAG`,
  ANALYTICS_TYPEAHEAD_CATEGORY: 'typeahead:category',
  NAVIGATION_CATEGORY: 'navigation:category',
  FETCH_TRENDING_SEARCH_PRODUCTS: 'FETCH_TRENDING_SEARCH_PRODUCTS',
  SET_TRENDING_SEARCH_PRODUCTS: 'SET_TRENDING_SEARCH_PRODUCTS',
};
